import React, { Component, Fragment } from 'react';
// import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import Modal from 'react-modal';
import { ProfileThumb } from '../';
import { Icon } from '../../Icon';
import { mobileCheck, gtmSend } from '../../../../helpers';
import NotificationSystem from 'react-notification-system';
import cx from '../../../../styles';
// import Loader from '../../Loader';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
if (typeof window != 'undefined') {
    Modal.setAppElement('#root');
}


class ReplyGenericInputModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false,
            anonymous: 0,
            ifShowAllTopics: false,
            groupId: '',
            mobileTitle: '',
            isShowNotification: true,
            isShowNotificationMessage: true,
            isClickSubmit: false,
            isNSFWChecked: 0
        };
        this._notificationSystem = null;
    }

    componentDidMount() {
        if (this.state.isShowNotification) {
            if (this.props.eventHandlers.refAddNotification) this.props.eventHandlers.refAddNotification(this._addNotification);
        }
        if (this.state.isShowNotificationMessage) {
            if (this.props.eventHandlers.refAddNotificationMessage) this.props.eventHandlers.refAddNotificationMessage(this._addNotificationMessage);
        }
        //mobile title
        const mobileTitle = this.props.mobileTitle || '';
        this.setState({ mobileTitle, isModalOpen: this.props.isModalOpen });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isModalOpen !== this.props.isModalOpen && !this.props.isModalOpen) {
            this.setState({ isClickSubmit: false }); // to stop page refresh on every alternate edit
        }
    }

    componentWillReceiveProps(nextProps) {
        // if(nextProps.isModalOpen != this.props.isModalOpen) {
        //     if(!nextProps.isModalOpen) {
        //         this.onRequestClose();
        //     } else {
        //         console.log('here1');
        //         this.setState({isModalOpen: true});
        //     }            
        // }
        //
        if (nextProps.switchState) {
            this.setState({ mobileTitle: this.props.t('select_a_topic') });
        }

        if (nextProps.isNSFWChecked && this.state.isNSFWChecked !== nextProps.isNSFWChecked) {
            this.setState({ isNSFWChecked: nextProps.isNSFWChecked });
        }
    }

    _addNotification = (message, level) => {
        if (this.state.isShowNotification) {
            this.setState({ isShowNotification: false });
            this._notificationSystem.addNotification({
                message: message,
                level: level,
                autoDismiss: 3,
                position: 'tc'
            });
            setTimeout(() => {
                this.setState({ isShowNotification: true });
            }, 3000);
        }
    }

    // created new for different autoDismiss time
    _addNotificationMessage = (message, level) => {
        if (this.state.isShowNotificationMessage) {
            this.setState({ isShowNotificationMessage: false });
            this._notificationSystem.addNotification({
                message: message,
                level: level,
                autoDismiss: 10,
                position: 'tc'
            });
            setTimeout(() => {
                this.setState({ isShowNotificationMessage: true });
            }, 10000);
        }
    }

    resetState = () => {
        this.setState({ anonymous: 0, ifShowAllTopics: false, groupId: '', mobileTitle: (this.props.mobileTitle ? this.props.mobileTitle : ''), isNSFWChecked: 0 });
    }

    onAfterOpen = () => {
        gtmSend('dynamic', this.props.gtmLabel, 'after-open', '');
        gtmSend(`${this.props.gtmLabel == 'Reply Input' ? 'cw_reply_compose' : `${this.props.gtmLabel == 'Booth Comment Compose' ? 'cw_reply_compose' : 'cw_post_compose'}`}`, `${this.props.cardName ? `${this.props.cardName}` : 'Post'}`, `${this.props.gtmLabel == 'Reply Input' ? 'Reply Compose' : `${this.props.gtmLabel == 'Booth Comment Compose' ? 'Reply Compose' : 'Compose'}`}`, '--', 0, this.props.cardName && this.props.topic ? { card_type: this.props.cardName, card_id: this.props.id, topic_id: this.props.topic.id } : {});
        this.resetState();
        if (this.props.eventHandlers.onModalOpen) this.props.eventHandlers.onModalOpen();
    }

    onRequestClose = (closeManually = false) => {
        gtmSend('dynamic', this.props.gtmLabel, 'click-close', closeManually ? 'manual' : 'not-manual');
        gtmSend(`${this.props.gtmLabel == 'Reply Input' ? 'cw_reply_compose' : `${this.props.gtmLabel == 'Booth Comment Compose' ? 'cw_reply_compose' : 'cw_post_compose'}`}`, `${this.props.cardName ? `${this.props.cardName}` : 'Post'}`, `${this.props.gtmLabel == 'Reply Input' ? 'Reply Compose' : `${this.props.gtmLabel == 'Booth Comment Compose' ? 'Reply Compose' : 'Compose'}`}`, 'Close', 0, this.props.cardName && this.props.topic ? { card_type: this.props.cardName, card_id: this.props.id, topic_id: this.props.topic.id } : {});
        if (this.props.isCompose && closeManually) {
            this.resetState();
            this.setState({ isModalOpen: false });
            if (this.props.eventHandlers.onModalClose) this.props.eventHandlers.onModalClose();
        } else if (!this.props.isCompose) {
            this.resetState();
            this.setState({ isModalOpen: false });
            if (this.props.eventHandlers.onModalClose) this.props.eventHandlers.onModalClose();
        }
    }

    onFormSubmitClick = (e) => {
        if (this.props.eventHandlers.onSubmit) {
            if (!this.state.isClickSubmit) { // to avoid submitting same question/reply multiple times
                if (this.props.content && !this.props.content.includes('covid')) { // to not set state to true if content contains covid so that page doesnt refresh if tried to click submit more than once
                    this.setState({ isClickSubmit: true });
                }
                this.props.eventHandlers.onSubmit(e);
            }
        }
    }

    ReplyModal = () => {
        const { content, imagePreviews, user, gtmLabel = 'Generic Input Modal', linkPreview = null, showUploadInput = false, showNSFW = false, showAnonymous = true, isCompose = false, isComment = false, ifEditing = false, contentPlaceholder = '', t, isMemory = false } = this.props;
        const { onImageUpload, onContentChange, onPreviewImageRemove, onLinkPreviewRemove } = this.props.eventHandlers;

        return (
            <div className={cx('ReplyModal')}>

                <div className="gim-head">
                    <div className={cx("left")}>
                        <ProfileThumb img={user.image && !this.state.anonymous ? user.image : ""} altName={`${user.fullname} profile icon`} />

                        <div>
                            <p>{!this.state.anonymous ? user.fullname : t('add_anonymous')}</p>
                            {
                                showAnonymous && !(ifEditing || isMemory) &&
                                <div className={cx("btn-check-label")}>
                                    <input id="anonymous-input" checked={this.state.anonymous} onChange={e => { this.setState({ anonymous: +e.target.checked }); gtmSend('dynamic', gtmLabel, 'click-anonymous', +e.target.checked); gtmSend(`${this.props.gtmLabel == 'Reply Input' ? 'cw_reply_compose' : 'cw_post_compose'}`, `${this.props.cardName ? this.props.cardName : 'Post'}`, `${this.props.gtmLabel == 'Reply Input' ? 'Reply Compose' : `${this.props.gtmLabel == 'Booth Comment Compose' ? 'Reply Compose' : 'Compose'}`}`, `${e.target.checked ? 'Anonymous' : 'Identified'}`, 0, this.props.cardName && this.props.topic ? { card_type: this.props.cardName, card_id: this.props.id, topic_id: this.props.topic.id } : {}); }} type="checkbox" />
                                    <label htmlFor="anonymous-input" className={cx("pointer-click")}>{t('post_anonymously')}</label>
                                </div>
                            }
                        </div>
                    </div>


                    <div className={cx("right")}>
                        <span className={cx("close-modal")} onClick={(/*e*/) => this.onRequestClose(true)} >
                            <Icon name="cross-regular-dark-smd" />
                        </span>
                    </div>
                </div>

                <form onSubmit={this.onFormSubmitClick}>
                    <div className={cx("gim-body", isComment ? "comment-body" : "")}>
                        <div className="input-wrap">
                            <div>

                                <textarea onChange={e => onContentChange(e.target.value)}
                                    onClick={() => { gtmSend('dynamic', gtmLabel, 'click-content', ''); gtmSend(`${this.props.gtmLabel == 'Reply Input' ? 'cw_reply_compose' : `${this.props.gtmLabel == 'Booth Comment Compose' ? 'cw_reply_compose' : 'cw_post_compose'}`}`, `${this.props.cardName ? this.props.cardName : 'Post'}`, `${this.props.gtmLabel == 'Reply Input' ? 'Reply Compose' : `${this.props.gtmLabel == 'Booth Comment Compose' ? 'Reply Compose' : 'Compose'}`}`, 'Content', 0, this.props.cardName && this.props.topic ? { card_type: this.props.cardName, card_id: this.props.id, topic_id: this.props.topic.id } : {}) }}
                                    id="generic-input-modal-desc"
                                    name="content" value={content} placeholder={contentPlaceholder}
                                    className={cx((linkPreview && linkPreview.url ? "is-preview-active" : ""))}
                                    autoFocus={!mobileCheck() && !isCompose ? true : false} />

                                {
                                    showUploadInput &&
                                    <div className={cx("only-mobile", "upload-mobile-btn")} >
                                        <label htmlFor="file-input-mobile" className={cx("bg-img")}><Icon name="camera-regular-gray-md" /></label>
                                        <input id="file-input-mobile" name="image" type="file" onChange={onImageUpload} multiple />
                                    </div>
                                }
                            </div>
                        </div>

                        {
                            imagePreviews.length !== 0 &&
                            <div className={cx("uploaded-img-wrap")}>
                                {
                                    imagePreviews.map((src, i) => {
                                        return (
                                            <div className={cx("uploaded-img", this.state.isNSFWChecked ? "nsfw-img" : "")} key={i}>
                                                <div className={cx("bg-img")} style={{ backgroundImage: `url(${src})` }}></div>
                                                <span className={cx("close")} onClick={() => onPreviewImageRemove(i)}>
                                                    <Icon name={"close-regular-black-sm"} />
                                                </span>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        }

                        {
                            showNSFW && !!imagePreviews.length &&
                            <div className={cx("btn-check-label", "not-safe")}>
                                <input id="nsfw-desktop" type="checkbox" name="nsfw" checked={this.state.isNSFWChecked} onChange={e => { this.setState({ isNSFWChecked: +e.target.checked }); gtmSend('dynamic', gtmLabel, 'click-nsfw', +e.target.checked); }} />
                                <label htmlFor="nsfw-desktop" className={cx("pointer-click")}>{t('nsfw_images_msg')}</label>
                            </div>
                        }

                        {
                            linkPreview && linkPreview.url &&
                            <div className="article-preview-wrap">
                                <div className={cx("article-link-preview-horizontal")} >
                                    <div className={cx("bg-img")} style={{ backgroundImage: `url(${linkPreview.linkData.thumbnail})` }}></div>
                                    <div>
                                        <h2><a href={linkPreview.linkData.url}>{linkPreview.linkData.title}</a></h2>
                                        <p>{linkPreview.linkData.description}</p>
                                    </div>
                                </div>
                                <span className={cx("close")} onClick={onLinkPreviewRemove}>
                                    <Icon name={"close-regular-black-sm"} />
                                </span>
                            </div>
                        }
                    </div>

                    <div className={cx("gim-bottom")}>
                        <div className={cx("left")}>
                            {
                                showUploadInput &&
                                <div className={cx("btn-image-upload")}>
                                    <label htmlFor="file-input">
                                        <Icon name={"camera-regular-black-sm"} />
                                    </label>
                                    <input id="file-input" name="image" type="file" onChange={onImageUpload} multiple onClick={() => { gtmSend(`${this.props.gtmLabel == 'Reply Input' ? 'cw_reply_compose' : 'cw_post_compose'}`, `${this.props.cardName ? this.props.cardName : 'Post'}`, `${this.props.gtmLabel == 'Reply Input' ? 'Reply Compose' : `${this.props.gtmLabel == 'Booth Comment Compose' ? 'Reply Compose' : 'Compose'}`}`, 'Add Photo', 0, this.props.cardName && this.props.topic ? { card_type: this.props.cardName, card_id: this.props.id, topic_id: this.props.topic.id } : {}); }} />
                                </div>
                            }
                        </div>

                        <div className={cx("right")}>
                            <input type="hidden" name="anonymous" value={this.state.anonymous} />
                            <input className={cx("btn", "btn-primary")} type="submit" value={this.props.buttonLabel ? this.props.buttonLabel : "post"} />
                        </div>
                    </div>
                </form>
            </div>
        );
    }
    render() {
        // let { user, t } = this.props;
        // let { onModalOpen, onModalClose, onImageUpload, onContentChange, onSubmit } = this.props.eventHandlers;
        const ReplyModal = this.ReplyModal;
        return (
            <Fragment>
                <Modal isOpen={this.props.isModalOpen}
                    onAfterOpen={this.onAfterOpen}
                    onRequestClose={this.onRequestClose}
                    overlayClassName={this.props.isComment ? "myOverlayClass reply-generic-input-modal-overlay comment-modal-overlay" : "myOverlayClass reply-generic-input-modal-overlay"}
                    style={typeof this.props.style !== 'undefined' ? this.props.style : customStyles}>
                    <div className={cx("reply-generic-input-modal")}>

                        <NotificationSystem ref={n => this._notificationSystem = n} />

                        <ReplyModal />
                    </div>
                </Modal>
            </Fragment>
        );
    }
}

export default translate()(ReplyGenericInputModal);